import { render, staticRenderFns } from "./BowMap.vue?vue&type=template&id=ffc2dcfa&"
import script from "./BowMap.vue?vue&type=script&lang=js&"
export * from "./BowMap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BowMarker: require('/workspace/components/atoms/BowMap/BowMarker.vue').default,BowImage: require('/workspace/components/atoms/BowImage/BowImage.vue').default,BowHeading: require('/workspace/components/atoms/BowHeading/BowHeading.vue').default})
